/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SwimwearInputs */

const en_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swimwear`)
};

const es_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trajes de baño`)
};

const fr_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maillots de bain`)
};

const de_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bademode`)
};

const ja_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水着`)
};

const zh_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`泳装`)
};

const ar_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملابس سباحة`)
};

const id_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakaian Renang`)
};

const it_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costumi da Bagno`)
};

const ru_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купальники`)
};

const pt_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moda Praia`)
};

const ko_val_swimwear = /** @type {(inputs: Val_SwimwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수영복`)
};

/**
* | output |
* | --- |
* | "Swimwear" |
*
* @param {Val_SwimwearInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_swimwear = /** @type {((inputs?: Val_SwimwearInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SwimwearInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_swimwear(inputs)
	if (locale === "es") return es_val_swimwear(inputs)
	if (locale === "fr") return fr_val_swimwear(inputs)
	if (locale === "de") return de_val_swimwear(inputs)
	if (locale === "ja") return ja_val_swimwear(inputs)
	if (locale === "zh") return zh_val_swimwear(inputs)
	if (locale === "ar") return ar_val_swimwear(inputs)
	if (locale === "id") return id_val_swimwear(inputs)
	if (locale === "it") return it_val_swimwear(inputs)
	if (locale === "ru") return ru_val_swimwear(inputs)
	if (locale === "pt") return pt_val_swimwear(inputs)
	return ko_val_swimwear(inputs)
});